import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { useOrderReceiptFileQuery } from '../api/queries/useOrderReceiptFileQuery'

/**
 * The order receipt row. Nothing is fetched until `load()` (the user clicked
 * View / Download); a receipt never changes, so it is cached per order for
 * the session and every page reuses the same blob.
 */
export function useOrderReceipt(
  orderId: MaybeRefOrGetter<string>,
  orderReference: MaybeRefOrGetter<string>,
) {
  const { file, load } = useOrderReceiptFileQuery(orderId, orderReference)

  return {
    isAvailable: computed(() => Boolean(toValue(orderId))),
    /** Known once the receipt has been fetched. */
    sizeBytes: computed(() => file.value?.sizeBytes ?? null),
    load,
  }
}
